import AdminSeniorVoUsersPanel from "../components/voyage-pnl/AdminSeniorVoUsersPanel";

const AdminSeniorVoUsersPage = () => <AdminSeniorVoUsersPanel />;

export default AdminSeniorVoUsersPage;
